import { Component, ElementRef, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { NotificationTypes } from 'src/app/app.enums';
import { ImageCroppedResponse } from 'src/app/common/image-cropper/image-cropper.component';
import { ArtFlowSelectItem } from 'src/app/models/artflow.selectitem';
import { ArtTypeService } from 'src/app/Services/art-type.service';
import { ArtistsService } from 'src/app/Services/artists.service';
import { ApplicationUser, AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { ArtistBankingInformation, UsersService } from 'src/app/Services/users.service';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-onboarding-artist-personal-details',
    templateUrl: './onboarding-artist-personal-details.component.html',
    styleUrls: ['./onboarding-artist-personal-details.component.css'],
    standalone: false
})
export class OnboardingArtistPersonalDetailsComponent implements OnInit {
  @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() onArtTypesUpdated = new EventEmitter<void>();

  public enableCropper: boolean = true;
  public currentSelectedImageToCrop?: File;
  public showCropperDialog: boolean = false;
  public additionalFiles: any[] = [];
  public selectedFile!: File;
  @Output() onSave = new EventEmitter<ApplicationUser>();
  public formData: ApplicationUser = new ApplicationUser();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  public userId!: string;
  public uploader!: FormGroup;
  public authConfig: AuthConfig = {};
  public isArtist: boolean | undefined = false;
  public isBankingInformtionDailogVisible: boolean = false;
  public loginUserId!: string;
  public artTypes: ArtFlowSelectItem[] = [];
  public selectedArtTypes: string[] = [];
  public artTypeDialogVisible = false;
  public selectCurrency: SelectItem[] = [];
  public isPasswordConfirmationDailogVisible: boolean = false;
  public upgradeDialogVisible = false;
  public numberOfArtTypeSelection!: number;
  public isFreePlanUser: boolean = true;
  public hasFreeTrailEnded: boolean | undefined;
  public isOnFreeTrial!: boolean;
  constructor(
    private router: Router,
    private authService: AuthService,
    private uploadService: CloudinaryImageService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private usersService: UsersService,
    private artTypeService: ArtTypeService,
    private artistsService: ArtistsService,
    private fb: FormBuilder,
    private transloco: TranslocoService
  ) {
    this.formData = new ApplicationUser();
    this.uploader = this.fb.group({
      file: [null],
    });
  }

  ngOnInit(): void {
    this.userId = this.authService.getUserId();
    this.authConfig = this.authService.getAuthConfig();
    this.isFreePlanUser = this.authService.isFreePlanUser();
    this.numberOfArtTypeSelection = this.authService.getArtTypeSelection(); this.getArtTypes();
    this.getArtistArtTypes();
    this.getArtTypes();
    this.getUserById();
    this.populateCurrencyOptions();
    this.hasFreeTrailEnded = this.authService.hasFreeTrialEnded();
    console.log("HasFreeTrailEnded: ", this.hasFreeTrailEnded)
    this.isOnFreeTrial = this.authService.isOnFreetrial();
    console.log("IsFreeTrail: ", this.isOnFreeTrial);
  }
  private populateCurrencyOptions() {
    this.selectCurrency = [
      { label: '--Select Currency--', value: '' },
      { label: 'Pakistan (Rupee)', value: 'PKR' },
      { label: 'US(Dollar)', value: 'USD' },
      { label: 'Euro', value: 'EUR' },
      { label: 'Australia (Dollar)', value: 'AUD' },
      { label: 'Canada (Dollar)', value: 'CAD' },
      { label: 'Yuan Renminbi', value: 'CNY' },
      { label: 'Indian (rupee)', value: 'INR' },
      { label: 'Ruble', value: 'RUB' },
      { label: 'Riyal', value: 'SAR' },
      { label: 'Lira', value: 'TRL' }
    ];
  }

  public onCurrencyChanged($event: any) {
    this.formData.CurrencyCode = $event.value;
  }

  private getUserById() {
    this.ngxSpinnerService.show();
    this.usersService.getUserDetails().subscribe(
      (res) => {
        this.formData = res;
        console.log(this.formData);
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error('Error fetching the logged-in user: ', error);
        this.ngxSpinnerService.hide();
      }
    );
  }


  public imgType: string = '';


  // File Selection Handler
  public onFileSelected(files: File[], imgType: string) {
    console.log(files);
    this.selectedFile = files[0]; // Get the selected file
    console.log(this.selectedFile);

    // Check if the selected file is an image
    const isImage = this.selectedFile && this.selectedFile.type.includes('image');
    if (isImage) {
      this.imgType = imgType; // Store the image type (ArtistImg or BusinessLogo)
      this.showCropperDialog = true; // Show cropper dialog
      this.currentSelectedImageToCrop = this.selectedFile; // Set the image to crop
    } else {
      console.log('Selected file is not an image');
    }
  }

  // Cropped Image Handler
  public onImageCropped(croppedImage: ImageCroppedResponse) {
    console.log(croppedImage);
    // Set the cropped image as the selected file
    this.selectedFile = croppedImage.CroppedImage;

    // Now upload the cropped image
    this.uploadImage(this.imgType);

    // Close the cropper dialog
    this.showCropperDialog = false;
  }

  // Image Upload Logic
  public uploadImage(value: string) {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('ImageFile', this.selectedFile);
      // Upload the cropped image based on the value (ArtistImg or BusinessLogo)
      if (value == 'ArtistImg') {
        this.uploadService.uploadImage(formData).subscribe((res: any) => {
          this.formData.ImgUrl = res;
        });
      } else if (value == 'BusinessLogo') {
        this.uploadService.uploadImage(formData).subscribe((res: any) => {
          this.formData.BusinessLogoUrl = res;
        });
      }
    } else {
      console.log('No image to upload.');
    }
  }

  // Remove Image Logic
  public removeImg(value: string) {
    if (value == 'ArtistImg') {
      this.formData.ImgUrl = null!;
    } else if (value == 'BusinessLogo') {
      this.formData.BusinessLogoUrl = null!;
    }
  }

  public onImageCropperClose($event: any) {
    // this.showCropperDialog = false;
    if ($event.skipCropping) {
      this.selectedFile = null!;
      this.showCropperDialog = false;
      if (this.fileUpload) {
        this.fileUpload.clear();
      }
      // Handle skipping cropping if needed
    }
  }






 public updateProfile() {
  this.isBankingInformtionDailogVisible = false;
  // Exclude primary art type from additional art types
  this.formData.ArtistArtTypes = this.selectedArtTypes.filter(
    id => id !== this.formData.PrimaryArtTypeId
  );
  this.ngxSpinnerService.show();
  this.usersService.updateUser(this.formData.Id, this.formData).subscribe(
    (response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        this.onSave.emit(this.formData);
        this.onArtTypesUpdated.emit(); // Notify parent
        this.notificationsService.showNotification(this.transloco.translate('onboardingArtistPersonalDetails.successTitle'), this.transloco.translate('onboardingArtistPersonalDetails.changesSavedSuccess'), NotificationTypes.Success);
      } else {
        this.notificationsService.showNotification(this.transloco.translate('onboardingArtistPersonalDetails.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
      }
    },
    (error) => {
      console.error(error);
      this.ngxSpinnerService.hide();
    }
  );
}

  public bankingFormData: ArtistBankingInformation = {};





  public getArtistBankingInfo() {
    this.ngxSpinnerService.show();
    this.usersService.getArtistBankingInfo(this.formData.Password).subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.formData.Password = '';
          this.isBankingInformtionDailogVisible = true;
          this.bankingFormData = response.ResponseData;
          this.notificationsService.showNotification(this.transloco.translate('onboardingArtistPersonalDetails.successTitle'), response.ResponseMessage, NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('onboardingArtistPersonalDetails.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public updateArtistBankingInformation() {
    this.ngxSpinnerService.show();
    this.usersService.updateArtistBankingInformation(this.bankingFormData).subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('onboardingArtistPersonalDetails.successTitle'), this.transloco.translate('onboardingArtistPersonalDetails.changesSavedSuccess'), NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('onboardingArtistPersonalDetails.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }


  private getArtTypes() {
    var filterRoleBasedArttypes = false;
    this.artTypeService.fetch(filterRoleBasedArttypes).subscribe((artTypeItems) => {
      this.artTypes = artTypeItems.map((item) => {
        return { label: item.Name, value: item.Id, selected: false };
      });
    }, (error) => { console.error(error); });
  }

  private getArtistArtTypes() {
    this.artistsService.getArtistArtTypes().subscribe((artistArttypeIds: string[]) => {
      this.selectedArtTypes = artistArttypeIds;
    }, (error) => { console.error(error); });
  }

  public openSelectArtTypeDialog() {
    this.artTypes.filter(p => this.selectedArtTypes.indexOf(p.value) >= 0).forEach(p => p.selected = true);
    this.artTypeDialogVisible = true;
  }

  public onApplySelectedArtTypes($event: any) {
    const selectedCount = this.artTypes.filter((p) => p.selected).length;
    if (this.isFreePlanUser && (this.hasFreeTrailEnded || !this.isOnFreeTrial) && selectedCount > this.numberOfArtTypeSelection) {
      this.upgradeDialogVisible = true;
      this.artTypeDialogVisible = false;
    } else {
      this.selectedArtTypes = this.artTypes
        .filter((p) => p.selected)
        .map((p) => p.value);
      this.artTypeDialogVisible = false;
    }
  }
  handleDialogClose(event: any) {
    this.upgradeDialogVisible = false;
  }

  public onArtTypeChange(event: any): void {
    const selectedCount = this.selectedArtTypes.length;
    if (this.isFreePlanUser && (this.hasFreeTrailEnded || !this.isOnFreeTrial) && selectedCount > this.numberOfArtTypeSelection) {
      this.selectedArtTypes.pop(); // Remove the last selected item
      this.upgradeDialogVisible = true;
    }
  }
  public onCloseBankingInformationDailog() {
    this.isBankingInformtionDailogVisible = false;
  }
  public onShowConfirmationDailog() {
    this.isBankingInformtionDailogVisible = true;
  }
  
get filteredArtTypes() {
  return this.artTypes.filter(a => a.value !== this.formData.PrimaryArtTypeId);
}

public onPrimaryArtTypeChange(primaryArtTypeId: string): void {
  // Remove the primary art type from additional art types if present
  this.selectedArtTypes = this.selectedArtTypes.filter(id => id !== primaryArtTypeId);
}

}
